<template>
    <!-- carregamento da pagina: indicador central que so aparece se demorar -->
    <div v-if="page" class="muven-loading muven-loading-page" role="status" aria-live="polite">
        <span class="muven-loading-orbit" aria-hidden="true"></span>
        <span class="muven-loading-message">{{message || 'Carregando'}}</span>
    </div>

    <!-- inline (botoes, listas): anel na cor do texto ao redor -->
    <span v-else class="muven-loading" role="status">
        <span class="muven-loading-ring" aria-hidden="true"></span>
        <span v-if="!!message" class="muven-loading-message">{{message}}</span>
        <span v-else class="sr-only">Carregando</span>
    </span>
</template>

<script>
export default {
    name: 'LoadingCmp',
    props: {
        message: {
            type: String,
            default: '',
        },
        page: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
$brand: var(--brand);
$brand-light: var(--brand-soft);
$brand-dark: var(--brand-strong);
$track: var(--tint-brand-border);
$muted: var(--text-muted);
$ease-out: cubic-bezier(.22, 1, .36, 1);

.muven-loading {
    margin: 0 auto;
    color: inherit;

    .muven-loading-message {
        margin-left: 15px;
    }
}

.muven-loading-ring {
    position: relative;
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: -.15em;

    &::before,
    &::after {
        content: '';
        position: absolute;
        inset: 0;
        border: 2px solid currentColor;
        border-radius: 50%;
    }

    &::before {
        opacity: .25;
    }

    &::after {
        border-color: currentColor transparent transparent transparent;
        animation: muven-loading-spin .7s linear infinite;
    }
}

.muven-loading-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 96px 0;
    animation: muven-loading-rise .4s $ease-out .25s both;

    .muven-loading-message {
        margin-left: 0;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: .01em;
        color: $muted;
    }
}

// arco em gradiente com cauda, como o "cometa" da barra do topo
.muven-loading-orbit {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    box-shadow: inset 0 0 0 3px $track;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: conic-gradient(from 0deg, transparent 0deg, color-mix(in srgb, #{$brand-light} 20%, transparent) 140deg, $brand 300deg, $brand-dark 360deg);
        -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px)); // theme-ignore: canal alfa da mascara
        mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px)); // theme-ignore: canal alfa da mascara
        animation: muven-loading-spin .8s linear infinite;
    }
}

@keyframes muven-loading-spin {
    to { transform: rotate(360deg); }
}

@keyframes muven-loading-rise {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: none; }
}

@keyframes muven-loading-fade {
    from { opacity: 0; }
    to   { opacity: 1; }
}

@keyframes muven-loading-pulse {
    0%, 100% { opacity: .35; }
    50%      { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
    .muven-loading-ring::after,
    .muven-loading-orbit::after {
        animation: muven-loading-pulse 1.4s ease-in-out infinite;
    }

    .muven-loading-page {
        animation-name: muven-loading-fade;
    }
}
</style>
